import React from "react";
import { useArtistDisplayName } from "@/api/hooks/useArtistDisplayName";
import { SparkleMaskedName } from "@/components/ui/SparkleMaskedName";

interface MaskExactProfessionalNameProps {
  value: string | number | null | undefined;
}

const MaskExactProfessionalName: React.FC<MaskExactProfessionalNameProps> = ({ value }) => {
  const displayName = useArtistDisplayName();
  const normalizedDisplayName = displayName.trim();
  const rawValue = value ?? "";
  const normalizedValue = String(rawValue).trim();

  if (
    normalizedDisplayName.length > 0 &&
    normalizedValue.length > 0 &&
    normalizedValue === normalizedDisplayName
  ) {
    return <SparkleMaskedName name={displayName} />;
  }

  return <>{rawValue}</>;
};

export default MaskExactProfessionalName;
